import { BackendParam } from "../services";

export function objectToBackendParams<T extends Object>(filters: T): BackendParam[] {
    const parametersRaw = Object.keys(filters).filter(x => hasValue(filters[x]))
        .map((key) => {
            if (!Array.isArray(filters[key]))
                return ({ name: key, value: filters[key] });
            if (Array.isArray(filters[key])) {
                return filters[key].map((value: any) => ({ name: key, value }));
            }
        });

    const parameters: BackendParam[] = flatArray(parametersRaw);
    const filteredParameters = parameters.filter(param => param && hasValue(param.value));
    return filteredParameters;
}

export function flatArray<T>(arrays: T[]): any[] {
    return [].concat.apply([], arrays);
}

export function hasValue(val: unknown): boolean {
    return val != null && val !== "" && val !== undefined;
}